import * as React from "react";
const SvgSelf = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 22.32 201.63 157", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M.215 22.325h201.396v4.76H.215zM50.422 53.243H151.51v4.753H50.422zM50.319 81.483h101.085v4.753H50.319zM0 112.397h201.396v4.753H0zM50.523 143.616h100.773v4.76H50.523zM50.523 174.537h100.773v4.749H50.523z", style: {
  fill: "currentColor"
} }));
export default SvgSelf;
